export class AuthenticationError extends Error {
  public constructor(message: string) {
    super(message)
    this.name = 'AuthenticationError'
  }
}

export class ForbiddenError extends Error {
  public constructor(message: string) {
    super(message)
    this.name = 'ForbiddenError'
  }
}

export class NotFoundError extends Error {
  public constructor(message?: string) {
    super(message)
    this.name = 'NotFoundError'
  }
}

export class ValidationError extends Error {
  public constructor(message?: string) {
    super(message)
    this.name = 'ValidationError'
  }
}

export class ConflictError extends Error {
  public constructor(message?: string) {
    super(message)
    this.name = 'ConflictError'
  }
}

export class UnprocessableEntityError extends Error {
  public constructor(message?: string) {
    super(message)
    this.name = 'UnprocessableEntityError'
  }
}
